// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container___ZTKV","controls":"Pagination_controls__xur_3"};